<script setup lang="ts">
import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import { useItemStore } from "@/stores/management/item";
import { ItemDataPayload, ItemDataResponse } from "@/types/interface/item";
import { mapOptionMultiselect, urlToObject } from "@/utils/helper";
import type { Header } from "vue3-easy-data-table";
import EasyDataTable from "vue3-easy-data-table";
import "vue3-easy-data-table/dist/style.css";

const idItem = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const itemStore = useItemStore();
const detailItem = ref<ItemDataResponse>();
const listItem = ref<any>();
const page = ref(1);
const limit = ref(10);
const showTable = ref(false);

const loadItems = async () => {
  const { success, message } = await itemStore.dispatchGetItems(1, 99);
  if (success) {
    listItem.value = mapOptionMultiselect(
      await itemStore.items.items,
      "id",
      "name"
    );
  }
};

loadItems();

const loadDetailItem = async () => {
  const { success, message } = await itemStore.dispatchDetail(idItem.value);

  if (success) {
    detailItem.value = await itemStore?.item?.data;
    showTable.value = true;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    idItem.value = router.currentRoute.value.params.id.toString();
    loadDetailItem();
  }
});

const headers: Header[] = [
  { text: "MSG CODE", value: "msg_code" },
  { text: "IMPA CODE", value: "impa_code" },
  { text: "TYPE", value: "key" },
  { text: "VALUE", value: "value" },
  { text: "Action", value: "action" },
];
</script>
<template>
  <div class="row justify-content-center my-3">
    <div class="d-flex justify-content-between align-items-center my-2">
      <a
        class="btn btn-danger fw-semibold text-white px-3"
        type="button"
        href="/management/catalog"
      >
        <i class="ri-arrow-drop-left-line text-gray-light"></i>
        Back To List Item
      </a>
    </div>
    <div class="col-lg-5">
      <div class="card card-catalog">
        <div class="mb-4 transition-y card-body">
          <div class="position-relative mb-3">
            <div class="image-box">
              <img
                :src="detailItem?.image_link"
                class="rounded-3"
                alt="detailItem?"
              />
            </div>
          </div>
          <div class="row">
            <div class="col-12 fs-15 mb-0">
              MSG CODE :
              <span class="fw-medium">{{ detailItem?.msg_code }}</span>
            </div>
            <div class="col-12 fs-15 mb-0">
              IMPA CODE :
              <span class="fw-medium">{{ detailItem?.impa_code }}</span>
            </div>
            <div class="col-12 fs-15 mb-0">
              Category :
              <span class="fw-medium">{{ detailItem?.category?.name }}</span>
            </div>
            <div class="col-12 fs-15 mb-0">
              Group Category :
              <span class="fw-medium">{{
                detailItem?.groupCategory?.name
              }}</span>
            </div>
            <div class="col-12 fs-15 mb-0">
              Item :
              <span class="fw-bold">{{ detailItem?.name }}</span>
            </div>
            <div class="col-12 fs-15 mb-0">
              Unit :
              <span class="fw-medium">{{ detailItem?.unitType?.name }}</span>
            </div>
            <div class="col-12 fs-15 mb-0">
              Size :
              <span class="fw-medium">{{ detailItem?.size }}</span>
            </div>
            <div
              class="col-12 fs-15 mt-4 text-center"
              v-if="detailItem?.variant.length == 0"
            >
              <button class="btn btn-primary btn-sm text-white">
                Add To Requisition
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-7" v-if="detailItem?.variant.length > 0">
      <div class="card bg-white border-0 rounded-3 mb-4">
        <div class="card-body p-4">
          <h5>Varian Data</h5>
          <div class="table-content mt-5" v-if="showTable">
            <EasyDataTable :headers="headers" :items="detailItem?.variant">
              <template #item-action>
                <div class="d-flex gap-2">
                  <button class="btn btn-primary btn-sm text-white">
                    Add To Requisition
                  </button>
                </div>
              </template>
            </EasyDataTable>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
